<template>
<modal :overlay-closes="false" wide title="Two Factor Authentication">
    <div class="columns">
      <div class="column has-text-centered">
        <p class="is-block">Scan the QR code shown below in your authenticator application. We recommend Google Authenticator.</p>
        <div class="mt-4" v-html="svg"></div>
      </div>
      <div class="column">
        <p class="has-text-info">Recovery Codes</p>
        <p class="help is-danger">Copy these Recovery Codes to a safe location. These recovery codes will only be shown once.</p>
        <div class="mt-4 box">
          <p v-for="(code, index) in recovery_codes" :key="index">{{ code }}</p>
        </div>
      </div>
    </div>

    <form>
      <div class="columns">
        <div class="column">
          <text-input 
            :error="$root.errorBag.code"
            v-model="challenge.code"
            required
            classes="has-addons"
            description="Enter the code provided by your two factor application">
            Code
            <template #right>
              <submit-button @submit="validateCode" class="is-rounded">Validate Code</submit-button>
            </template>
          </text-input>
        </div>
      </div>
    </form>
</modal>  
</template>
<script>
export default {
  
  data: () => ({
    svg: null,
    recovery_codes: [],
    challenge: {
      code: ''
    },
    loading: true
  }),

  created() {
    Promise.all([
      this.$store.dispatch('auth/get2FaQrCode').then(({data}) => {
        this.svg = data.svg
      }),
      this.$store.dispatch('auth/get2FaRecoveryCodes').then(({data}) => {
        this.recovery_codes = data
      })
    ]).then(() => {
      this.loading = false
    })
  },

  methods: {
    validateCode() {
      this.$store.dispatch('auth/finalise2FaSetup', this.challenge).then(() => {
        this.$close(true)
        this.$toast.success('Two Factor Authentication Successfully Setup.')
      }).catch(error => {
        console.log(error)
      })
    }
  }

}
</script>